export default __webpack_public_path__ + "static/media/sex-og-samfunn-logo.a90ef276.png";